
jQuery('.testimonial-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
});
jQuery('.logos-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 8000,
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 12000
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 10000
            }
        }
    ]
});
jQuery('.logos-slider-2').attr('dir', 'rtl');
jQuery('.logos-slider-2').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 8000,
    dots: false,
    arrows: false,
    rtl: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 12000
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 10000
            }
        }
    ]
});
jQuery('.news-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});
jQuery('.projects-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1
            }
        },
    ]
});